import { SubscriptionActivationLimitTrigger } from 'protocol/api/billing_new/dto_product_new_pb';

import { SubscriptionActivationLimitTriggerOption } from './types';

export const SUBSCRIPTION_ACTIVATION_LIMIT_TRIGGER_OPTIONS: SubscriptionActivationLimitTriggerOption[] =
  [
    SubscriptionActivationLimitTrigger.SubscriptionActivationLimitTrigger_Analysis2DExhausted,
    SubscriptionActivationLimitTrigger.SubscriptionActivationLimitTrigger_Analysis3DExhausted,
    SubscriptionActivationLimitTrigger.SubscriptionActivationLimitTrigger_Analysis2DOr3DExhausted,
    SubscriptionActivationLimitTrigger.SubscriptionActivationLimitTrigger_Analysis2DAnd3DExhausted,
  ];
